; function BinaryReader(arrayBuffer) {
    var p = 0, v = new DataView(arrayBuffer);
    this.u8 = function () { return v.getUint8(p++); };
    this.u16 = function () { var t = p; p += 2; return v.getUint16(t, 1); };
    this.i16 = function () { var t = p; p += 2; return v.getInt16(t, 1); };
    this.u32 = function () { var t = p; p += 4; return v.getUint32(t, 1); };
    this.i32 = function () { var t = p; p += 4; return v.getInt32(t, 1); };
    this.f32 = function () { var t = p; p += 4; return v.getFloat32(t, 1); };
    this.chr = function () {
        var c = v.getUint8(p++);
        return (c < 128) ? c
            : (c < 224) ? ((c & 31) << 6) | (v.getUint8(p++) & 63)
                : (c < 240) ? ((c & 15) << 12) | ((v.getUint8(p++) & 63) << 6) | (v.getUint8(p++) & 63)
                    : (c < 248) ? ((c & 7) << 18) | ((v.getUint8(p++) & 63) << 12) | ((v.getUint8(p++) & 6) << 6) | (v.getUint8(p++) & 63)
                        : -1;
    }
    this.str = function () {
        var len = this.chr(), end = p + len;
        var t = [];
        while (p < end) t.push(this.chr());
        return String.fromCharCode.apply(null, t);
    };
}

String.prototype.toBuffer = function () {
    var buf = new ArrayBuffer(this.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0, strLen = this.length; i < strLen; i++) bufView[i] = this.charCodeAt(i);
    return buf;
}

if (!Object.values) {
    Object.values = function (data) {
        var res = [];
        for (var index in data) {
            res.push(data[index]);
        }
        return res;
    }
}